import React from "react";
import ReactDOM from "react-dom";
import QueryProvider from "v2/ui/Providers/QueryProvider";
import { Permission } from "v2/domain/common/entities/ManagerPermission/ManagerPermission";
import ProtectedRoute from "app/routes/ProtectedRoute";
import BenefitPage from "../components/BenefitPage";
import { findCompanyDetail } from "../../../infrastructure/repository/company-repository";
import { findModels } from "../../../infrastructure/repository/benefit-models-repository";
import { addContextLog } from "../../../infrastructure/log";

export function renderBenefitPage({ benefitModelIds, items, ...rest }) {
  ReactDOM.render(
    <QueryProvider>
      <ProtectedRoute permissions={[Permission.CAN_ACCESS_BENEFITS_SECTION]}>
        <BenefitPage
          benefitModelIds={benefitModelIds}
          listItems={items}
          {...rest}
        />
      </ProtectedRoute>
    </QueryProvider>,

    document.getElementById("page-container")
  );
}

export async function displayBenefitPage(modelId) {
  const { data } = await findCompanyDetail();
  const { data: benefitsModels } = await findModels();

  const {
    insuranceProducts,
    pricingType,
    benefitConfigs,
    countryISO2Code: country,
    retirementInsuranceBenefit,
    pensionPlanBenefit,
    id,
    gymBenefit,
  } = data;

  const benefitModelIds = [];
  let items = {};

  benefitsModels.map((i) => {
    benefitModelIds.push(i.id);
    items = { ...items, [i.id]: i };
    return items;
  });

  renderBenefitPage({
    modelId: modelId || benefitModelIds[0],
    benefitModelIds,
    items,
    insuranceProducts,
    v2BenefitsConfig: {
      retirementInsuranceBenefit,
      pensionPlanBenefit,
    },
    pricingType,
    benefitConfigs,
    country,
    companyId: id,
    companyGymBenefit: gymBenefit,
  });
  addContextLog("info", "displayBenefitPage", "display-screen", {
    modelId,
    benefitsModels,
    insuranceProducts,
    pricingType,
  });
}
